import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductCode } from '../../../../model/finzy-flex/product-list.model';
import { AttributeCode, InvestmentPreference, UserAttribute } from '../../../../model/finzy-flex/user-attribute.model';

@Component({
    selector: 'app-swift-attribute',
    templateUrl: './swift-attribute.component.html',
    styleUrls: ['./swift-attribute.component.css']
})
export class SwiftAttributeComponent implements OnInit {
    public formBuilder: FormBuilder;
    public subProducts = [];

    @Input()
    userAttributesSwiftForm?: FormGroup;

    @Input()
    isSwiftEnabled?: boolean;

    @Input()
    backupSwiftAttribute?: InvestmentPreference[] = [];

    @Input()
    applicableProducts?: any;

    @Input()
    userAttributes?: InvestmentPreference[] = [];

    @Input()
    havePreferencesChanged: any;

    @Input()
    previousUserAttribute: UserAttribute;

    @Output()
    changeValue: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(formBuilder: FormBuilder) {
        this.formBuilder = formBuilder;
    }

    ngOnInit(): void {
        this.initializeForm();
    }

    private async initializeForm() {
        this.fundAllocationPercent.clear();
        this.applicableProducts?.forEach((product: any) => {
            if (new Date(product.productVersions[0].startDate).getTime() <= new Date().getTime() &&
                new Date().getTime() <= new Date(product.productVersions[0].endDate).getTime()) {
                this.subProducts.push({
                    name: product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME) ? product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME).value.toString() : product.name,
                    mhp: product.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP_FRONTEND_DISPLAY)?.value,
                    mhpName: product.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP)?.name ?? 'mhp',
                    roi: product.productVersions[0].productAttributes.find(roi => roi.code === ProductCode.ROI).value,
                    maturity_days: product.productVersions[0].productAttributes.find(attribute => attribute.code === ProductCode.MATURITY_DAYS)?.value,
                });
                this.fundAllocationPercent.push(
                    this.formBuilder.group({
                        attributeCode: AttributeCode.INVESTMENT_FUND_ALLOCATION,
                        attributeValue: this.formBuilder.control(this.getPreviousSwiftValue(product.code), [Validators.min(0), Validators.max(100)]),
                        productCode: product.code,
                        productVersion: product.productVersions[0].productVersion
                    })
                )
            }
        });
    }

    private getPreviousSwiftValue(productCode: string): number {
        if (this.isSwiftEnabled) {
            const attributeValue = this.backupSwiftAttribute.find(attr => attr.productCode === productCode)?.attributeValue;
            return attributeValue ? parseInt(attributeValue) : null;
        }
        return;
    }

    get fundAllocationPercent(): FormArray {
        return this.userAttributesSwiftForm.controls['fundAllocationPercent'] as FormArray;
    }

    public isNumberKey(e): boolean {
        const charCode = (e.which) ? e.which : e.keyCode;
        return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }

    public onInputChanges(): any {
        this.changeValue.emit(this.havePreferencesChanged());
    }
}
